/**
 * Incrementa o valor atual em 1.
 *
 * @param {number|string} x - Valor atual.
 * @returns {number}
 */
export function inc(x) {
  return Number(x) + 1;
}
